// extracted by mini-css-extract-plugin
module.exports = {"root":"signup_root__RQEly","content":"signup_content__cqItG","title":"signup_title__3NFDU","question":"signup_question__1jo7Z","buttons":"signup_buttons__5YCMC"};